/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TeamStatus } from './TeamStatus';
import {
    TeamStatusFromJSON,
    TeamStatusFromJSONTyped,
    TeamStatusToJSON,
} from './TeamStatus';

/**
 * 
 * @export
 * @interface UpdateTeamStatusRequest
 */
export interface UpdateTeamStatusRequest {
    /**
     * 
     * @type {TeamStatus}
     * @memberof UpdateTeamStatusRequest
     */
    status: TeamStatus;
}

/**
 * Check if a given object implements the UpdateTeamStatusRequest interface.
 */
export function instanceOfUpdateTeamStatusRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function UpdateTeamStatusRequestFromJSON(json: any): UpdateTeamStatusRequest {
    return UpdateTeamStatusRequestFromJSONTyped(json, false);
}

export function UpdateTeamStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTeamStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': TeamStatusFromJSON(json['status']),
    };
}

export function UpdateTeamStatusRequestToJSON(value?: UpdateTeamStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': TeamStatusToJSON(value.status),
    };
}

